import Alpine from "alpinejs";
import Swiper from "swiper/bundle";
import AOS from "aos";

AOS.init({ disable: "mobile" });

window.Alpine = Alpine;

Alpine.start();

// Adds Tailwind variables to the global scope
// import "./setup/tailwind-setup.js";

// Import JavaScript components
// import './components/accordion';
// import './components/tabs';
// import './components/toggle';

//If you want cookie consent
// import "./modules/cookie-consent";

//If you need a class to be toggled on a different element
// import "./modules/toggle";

//If you need to do something when its in/out of the viewport
// import "./modules/intersects";

const swiperElements = document.querySelectorAll(".swiper-container");
swiperElements.forEach((el) => {
	const count = el.classList.contains("swiper-count-3") ? 3 : 4;
	const observer = new IntersectionObserver((entries, observer) => {
		entries.forEach((entry) => {
			if (entry.isIntersecting) {
				const swiper = new Swiper(el, {
					slidesPerView: 1.25,
					spaceBetween: 8,
					breakpoints: {
						1024: {
							slidesPerView: count,
							spaceBetween: 8,
						},
					},
				});

				observer.disconnect();
			}
		});
	});

	observer.observe(el);
});
